import axios from 'axios';

export default {
  namespaced: true,
  state: {
    data: {
      total: 0,
      page: 1,
    },
    comunityList: {},
    formInline: {
      projectId: ''
    }
  },
  mutations: {
    fansList(state, { data = {} }) {
      state.data = data;
    },
    comunityList(state, { data = {} }) {
      state.comunityList = data;
    },
  },
  actions: {
    fansList({ commit }, params) {
      return axios.get('/wxfans/ajax/list', {
        params: params,
        cache: true,
      }).then((data) => {
        commit({ type: 'fansList', data: data.data });
      });
    },
    getComunityList({ commit }, params) {
      return axios.get('/wxnews/ajax/getComunityList', {
        params: params,
      }).then((data) => {
        // return data;
        commit({ type: 'comunityList', data: data.data });
      });
    }
  },
};
